import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { PruHttpService } from '../../../services/pru-http.service';
import { GenericService } from '../../../services/generic.service';

@Injectable({
  providedIn: 'root'
})
export class AccountsService {
  private defaultBaseApiUrl = '/api/co/secure/myaccounts/v2/accountsummary';

  constructor(
    private pruHttpService: PruHttpService,
    private genericService: GenericService
  ) {}

  getAccounts(productType: string, clearCache = true): Observable<any> {
    let apiUrl = `${this.defaultBaseApiUrl}?buName=${productType}`;

    if (clearCache) {
        apiUrl = `${apiUrl}&clearcache=${this.genericService.xPruId}`;
    }

    return this.pruHttpService.get(apiUrl, 'AccountsService').pipe(
      catchError((err) => of(err.error))
    );
  }
}
